import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoadingStatusUpdateInfo } from '@caslink/common-client/ng-app/alerts/typings/models';
import { SubscriptionTypes } from '@caslink/common-client/ng-app/alerts/typings/SubscriptionTypes';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';
import { IconSize } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimation';
import { NotificationService } from '@caslink/common-client/ng-app/notification/NotificationService';
import { EventTypes } from '@caslink/common-client/src';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dl-hardware-item-sync-loading-animation',
    templateUrl: './hardware-item-sync-loading-animation.component.html',
    styleUrls: ['./hardware-item-sync-loading-animation.component.scss']
})
export class HardwareItemSyncLoadingAnimationComponent implements OnInit, OnDestroy {
    public static $name: string = 'dlHardwareItemSyncLoadingAnimation';
    @Input() public message = '';
    @Input() public size: IconSize;
    @Input() public requestContext: string;
    @Input() public locationId: number;

    public globalSubscriptionType: SubscriptionTypes = SubscriptionTypes.HardwareItemSyncLoadingStatus;

    private hardwareItemSyncLoadingStatusUpdateSubscription: Subscription;

    constructor(
        private notificationService: NotificationService,
        private commonBroadcastService: CommonBroadcastService
    ) {
    }

    public ngOnInit() {
        this.notificationService.startUpdates(this.locationId, this.globalSubscriptionType, {}, null);

        this.hardwareItemSyncLoadingStatusUpdateSubscription = this.commonBroadcastService.on(EventTypes.HardwareItemSyncLoadingStatusUpdate)
            .subscribe((data: LoadingStatusUpdateInfo) => this.message = data.message);
    }

    public ngOnDestroy() {
        if (this.hardwareItemSyncLoadingStatusUpdateSubscription) { this.hardwareItemSyncLoadingStatusUpdateSubscription.unsubscribe() }
        this.notificationService.stopUpdates(this.locationId, this.globalSubscriptionType, {});
    }
}
